import React, {useEffect, useState, ReactElement} from 'react';
import FeatureFlagService, {FeatureFlags} from '../../services/FeatureFlagService';
import Navbar, {NavbarProps} from './Navbar';

const FeatureFlaggedNavbar = (props: NavbarProps): ReactElement | null => {
  const [retrievedFeatureFlags, setRetrievedFeatureFlags] = useState<FeatureFlags | null>(null);
  const [menus, setMenus] = useState<NavbarProps['menus']>(props.menus);

  useEffect(() => {
    const featureFlags = [...(props.featureFlags || [])];

    props.menus.forEach((menu) => {
      if ('menuItems' in menu && menu.menuItems) {
        menu.menuItems.forEach((item) => {
          if (item.requiresAnyFeatureFlag) {
            featureFlags.push(...item.requiresAnyFeatureFlag);
          }
        });
      }

      if ('requiresAnyFeatureFlag' in menu && menu.requiresAnyFeatureFlag) {
        featureFlags.push(...menu.requiresAnyFeatureFlag);
      }
    });

    if (featureFlags.length) {
      FeatureFlagService.getFeatureFlagStatuses(featureFlags).then(setRetrievedFeatureFlags);
    } else {
      setRetrievedFeatureFlags({});
    }
  }, []);

  useEffect(() => {
    if (retrievedFeatureFlags) {
      const newMenus: NavbarProps['menus'] = [];
      props.menus.forEach((menu) => {
        const newMenu = {...menu};

        if ('menuItems' in newMenu && newMenu.menuItems) {
          const menuItems = newMenu.menuItems.filter((item) => {
            if (item.requiresAnyFeatureFlag) {
              return item.requiresAnyFeatureFlag.some((flag) => retrievedFeatureFlags[flag]);
            }

            return true;
          });

          if (menuItems.length) {
            newMenu.menuItems = menuItems;
          }
        }

        if ('requiresAnyFeatureFlag' in newMenu && newMenu.requiresAnyFeatureFlag) {
          if (!newMenu.requiresAnyFeatureFlag.some((flag) => retrievedFeatureFlags[flag])) {
            return;
          }
        }

        newMenus.push(newMenu);
      });
      setMenus(newMenus);
    }
  }, [retrievedFeatureFlags]);

  if (retrievedFeatureFlags === null) {
    return null;
  }

  return <Navbar {...props} menus={menus} />;
};

FeatureFlaggedNavbar.defaultProps = {
  routed: true,
};

export default FeatureFlaggedNavbar;
